import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'

import track from '@/core/utils/tracking/track'
import { LearnpathsSummaryDetailsTabPanel } from '@/learnpaths-summary/components/LearnpathsSummaryDetailsTabPanel/LearnpathsSummaryDetailsTabPanel'
import LearnpathsSummaryDetailsTabsInfo from '@/learnpaths-summary/components/LearnpathsSummaryDetailsTabsInfo/LearnpathsSummaryDetailsTabsInfo'

export const Route = createFileRoute(
  '/company/_management/learnpaths/overview/$learnpathId/details',
)({
  component: DetailsTab,
})

function DetailsTab() {
  const { learnpathId } = Route.useParams()

  useEffect(() => {
    track('LP details tab viewed', { learnpath_id: learnpathId })
  }, [learnpathId])

  return (
    <LearnpathsSummaryDetailsTabPanel>
      <LearnpathsSummaryDetailsTabsInfo />
    </LearnpathsSummaryDetailsTabPanel>
  )
}
